<template>
  <div id="app" class="container">
    <router-view/>
  </div>
</template>

<script>
  export default {
    computed: {
      loading () {
        return this.$store.getters.loading
      }
    }
  }
</script>

<style scoped>
  #app {
    margin-top: 5%;
  }
</style>
